import {StoreAccountPlanType} from '../constants/storeType';
import {LaboratoryInputGroups} from '../../utilities/helper/inputGroup/inputGroups';
import {
  AdvertisementType,
  InputGroupCode,
} from '../../utilities/helper/unitGenerator/unit.types';
import {IRestrictedInputGroups} from '../types/restrictedInputGroup';

export const restrictedStoreInputGroups: IRestrictedInputGroups = {
  [StoreAccountPlanType.Dokan]: {
    [AdvertisementType.SALE]: [
      InputGroupCode.TOOL,
      InputGroupCode.FERTILIZER,
      InputGroupCode.SEED,
      InputGroupCode.PESTICIDE,
    ],
    [AdvertisementType.PROVIDED_SERVICE]: [],
    [AdvertisementType.PROVIDED_RENT]: [],
  },
  [StoreAccountPlanType.Plough]: {
    [AdvertisementType.SALE]: [InputGroupCode.MACHINERY],
    [AdvertisementType.PROVIDED_SERVICE]: [InputGroupCode.MACHINERY],
    [AdvertisementType.PROVIDED_RENT]: [InputGroupCode.MACHINERY],
  },
  [StoreAccountPlanType.Boneh]: {
    [AdvertisementType.SALE]: [],
    [AdvertisementType.PROVIDED_SERVICE]: [InputGroupCode.EMPLOYEE],
    [AdvertisementType.PROVIDED_RENT]: [],
  },
  [StoreAccountPlanType.Nasagh]: {
    [AdvertisementType.SALE]: [InputGroupCode.FARM],
    [AdvertisementType.PROVIDED_SERVICE]: [],
    [AdvertisementType.PROVIDED_RENT]: [InputGroupCode.FARM],
  },
  [StoreAccountPlanType.Laboratory]: {
    [AdvertisementType.SALE]: [
      LaboratoryInputGroups.WaterAndSoil,
      LaboratoryInputGroups.Animal,
      LaboratoryInputGroups.FertilizerPesticide,
      LaboratoryInputGroups.Plant,
    ],
    [AdvertisementType.PROVIDED_SERVICE]: [
      LaboratoryInputGroups.WaterAndSoil,
      LaboratoryInputGroups.Animal,
      LaboratoryInputGroups.FertilizerPesticide,
      LaboratoryInputGroups.Plant,
    ],
    [AdvertisementType.PROVIDED_RENT]: [
      LaboratoryInputGroups.WaterAndSoil,
      LaboratoryInputGroups.Animal,
      LaboratoryInputGroups.FertilizerPesticide,
      LaboratoryInputGroups.Plant,
    ],
  },
  [StoreAccountPlanType.NoStore]: {},
};
